import { PlayerLayout, VideoPlayerOpenReason } from '@core/player/types';
export const initialState = {
    actions: {},
    //
    isUserPaused: undefined,
    isUserMuted: undefined,
    //
    isVisible: false,
    //
    initialLayout: PlayerLayout.DEFAULT,
    isLayoutChangedByUser: false,
    layout: PlayerLayout.DEFAULT,
    layoutSize: { width: 0, height: 0 },
    isDesktop: false,
    uiZoom: 1,
    //
    openReason: VideoPlayerOpenReason.DEFAULT,
    //
    initTrackingHasBeenCalled: false,
    //
    navigationLocked: false,
    //
    isIMAActive: false,
    videosWatchedCount: 0,
    //
    interruptionCallbacks: {},
    scrolledToInitialVideo: false,
};
